import { useCallback } from 'react';
import { UnitsEnum } from '../../impl/blfApi/apiConstants';
import {
  useGetUserMeQuery,
  useUpdateUserMutation,
} from '../../impl/blfApi/endpoints/users';
import { defaultUserSettings, useSettings } from './useSettings';

export const usePreferredUnits = (): {
  preferredUnits: UnitsEnum | undefined;
  setPreferredUnits: (newUnits: UnitsEnum) => void;
} => {
  const { data: user } = useGetUserMeQuery();
  const { settings, isSettingsLoading } = useSettings();

  const [updateUser] = useUpdateUserMutation();

  const setPreferredUnits = useCallback(
    async (units: UnitsEnum) => {
      if (user?.id && !isSettingsLoading) {
        try {
          await updateUser({
            id: user.id,
            settings: {
              ...(settings ?? defaultUserSettings),
              units,
            },
          }).unwrap();
        } catch (error) {
          console.error(error);
          throw new Error('Failed to update preferred units');
        }
      }
    },
    [user?.id, settings, updateUser, isSettingsLoading]
  );

  return {
    preferredUnits: settings?.units,
    setPreferredUnits,
  };
};
